module.exports = __webpack_public_path__ + "static/media/photo.1eba2cab.svg";